import React from "react";

// Contenu du tutoriel de l'écran "Congés" — réservé aux collaborateurs
// (pas affiché pour les administrateurs, voir Conges.js) : une seule étape,
// une seule image, pour tout expliquer d'un coup. Affiché par le composant
// générique TutorialOverlay (src/components/ui/TutorialOverlay.js). "image"
// est volontairement vide pour l'instant : capture d'écran à ajouter
// ensuite.
const congesTutorial = [
  {
    image:
      "https://nrcdumqfyl1z2bwl.public.blob.vercel-storage.com/tutoriel/bureau/Capture%20d%E2%80%99%C3%A9cran%202026-07-31%20133925.png",
    title: "Comment fonctionne Congés ?",
    legende: "",
    description: (
      <>
        Choisissez le <strong>type d'absence</strong>, les dates{" "}
        <strong>Du / Au</strong> — le nombre de jours se calcule
        automatiquement — puis précisez un motif si besoin (facultatif) et
        envoyez la demande.
        <br />
        <br />
        Elle apparaît immédiatement dans <strong>« Mes demandes »</strong>{" "}
        avec le statut <strong>« En attente »</strong>, et{" "}
        <strong>un mail part automatiquement aux administrateurs</strong>{" "}
        pour qu'ils la traitent.
        <br />
        <br />
        Une fois traitée, le statut passe à <strong>Approuvé</strong> ou{" "}
        <strong>Refusé</strong> — vous êtes alors{" "}
        <strong>prévenu automatiquement par mail</strong>.
        <br />
        <br />
        Tant que votre demande est <strong>encore en attente</strong>, vous
        pouvez l'annuler vous-même avec l'icône corbeille — impossible dès
        qu'elle a été traitée.
      </>
    ),
  },
];

export default congesTutorial;
